import Axios from "axios";
import { AdminService_URL } from "../Url";
import { ROLES } from "../../constants/index";
import HashMap from "hashmap";

var map = new HashMap();
var err;

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const OnlineActions = {
  CHANGE_STATUS: "CHANGE_STATUS",
  CHANGE_STATUS_FAILURE: "CHANGE_STATUS_FAILURE",
};

//////////////////////////////////////////////////////
//? User Online service
//////////////////////////////////////////////////////

// export const changeStatus = (props) => {
//   return async (dispatch) => {
//     try {
//       let response = await Axios({
//         method: "POST",
//         url: `${AdminService_URL}/user/available?status=${props.status}&userLoggedIn=${props.userLoggedIn}`,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + props.access_token,
//         },
//       });
//       dispatch({
//         type: OnlineActions.CHANGE_STATUS,
//         payload: response.data,
//       });
//     } catch (error) {
//       if (error.response) {
//         switch (error.response.status) {
//           case 400:
//             map = objToStrMap(JSON.parse(JSON.stringify(error.response.data)));

//             map.forEach((ele) => (error = ele));

//             console.log("request failed", error);
//             dispatch({
//               type: OnlineActions.CHANGE_STATUS_FAILURE,
//               payload: error,
//             });
//             break;
//           case 404:
//             map = objToStrMap(JSON.parse(JSON.stringify(error.response.data)));

//             map.forEach((ele) => (error = ele));

//             console.log("request failed", error);
//             dispatch({
//               type: OnlineActions.CHANGE_STATUS_FAILURE,
//               payload: error,
//             });
//             break;
//           case 500:
//             dispatch({
//               type: OnlineActions.CHANGE_STATUS_FAILURE,
//               payload: error,
//             });
//             break;
//           default:
//             dispatch({
//               type: OnlineActions.CHANGE_STATUS_FAILURE,
//               payload: "Unknown Error",
//             });
//             break;
//         }
//       } else {
//         dispatch({
//           type: OnlineActions.CHANGE_STATUS_FAILURE,
//           payload: "Internal Server Error",
//         });
//       }

//       dispatch({
//         type: OnlineActions.CHANGE_STATUS_FAILURE,
//         payload: error.message ? error : error.response,
//       });
//     }
//   };
// };

export const changeStatusActions = {
  CHANGE_STATUS: "CHANGE_STATUS",
  CHANGE_STATUS_FAILURE: "CHANGE_STATUS_FAILURE",
};

export const changeStatus = (props) => {
  return async (dispatch) => {
    try {
      let response = await Axios({
        method: "POST",
        url: `${AdminService_URL}/user/available?status=${props.status}&userLoggedIn=${props.userLoggedIn}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.access_token,
        },
      });
      dispatch({
        type: changeStatusActions.CHANGE_STATUS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: changeStatusActions.CHANGE_STATUS_FAILURE,
        payload: error.message ? error : error.response,
      });
    }
  };
};
